export const fluidCoilCodes = ["CCF", "CHF", "RCF", "RHF", "FCF", "FHF"];
export const temperatureProperties = ["fluidtempin", "fluidtempout"];
